export default "__VITE_ASSET__d66e8264__"